/**
 * @author Ivan Toth.
 *  Stores data about app settins, like country, user profile
 */
var SettingsService = (function () {
    function SettingsService(socket, env) {
        var _this = this;
        this.socket = socket;
        this.env = env;
        this.socket.on('connect', function () {
            if (!_this.connected && angular.isDefined(_this.env.user) && _this.env.user.loggedIn) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getGlobalSettings',
                        script: '/config/config',
                        data: {},
                        token: _this.env.user.token
                    }
                });
            }
            _this.connected = true;
        });
        this.socket.on('disconnect', function () {
            _this.connected = false;
        });
        this.up = {};
        this.loaded = false;
        this.iot_list = {
            calculated: false,
            iots: []
        };
        this.eligibilityOptions = ['Eligible', 'Not Eligible'];
        this.bpoiEligibilityOptions = ['BP ID', 'IBM ID', 'Not Eligible'];
        this.calculationTreeLevels = ['Payment', 'Sales Order', 'Brand Family', 'Part Number', 'Revenue Line Item'];
    }
    /**
     * getNextMainStatus - Function to get the next main status in the process sequence whether moving forward or backards
     *
     * @return {number}  The next main status number
     */
    SettingsService.prototype.getNextMainStatus = function (currentStatus, program, rollback) {
        var nextStatus = currentStatus; //Set as current is case all fails
        if (this.program_cfg) {
            this.program_cfg.some(function (prog) {
                if (prog.title === program) {
                    var index = prog.process_seq.indexOf(currentStatus);
                    if (!rollback) {
                        //If going forward
                        if (index + 1 <= prog.process_seq.length) {
                            nextStatus = prog.process_seq[index + 1];
                        }
                    }
                    else {
                        //Going back
                        if (index - 1 >= 0) {
                            nextStatus = prog.process_seq[index - 1];
                            //if that new status is an approval status then go back one more
                            if ([2, 5].indexOf(nextStatus) > -1) {
                                nextStatus = prog.process_seq[index - 2];
                            }
                        }
                    }
                    return true; //Break loop
                }
            });
        }
        return nextStatus;
    };
    SettingsService.prototype.getProgramProfile = function (name) {
        var program;
        if (angular.isDefined(this.program_cfg)) {
            angular.forEach(this.program_cfg, function (prog) {
                if (name === prog.title) {
                    program = prog;
                }
            });
        }
        return program;
    };
    SettingsService.prototype.updateSettings = function (data) {
        this.country_list = data.country_list;
        this.teams = data.teams;
        this.columnNames = data.columnNames;
        this.allColumnOrder = data.allColumnOrder;
        this.svistatuses = data.svistatuses;
        this.bp_types = data.bp_types;
        this.brands = data.brands;
        this.programs = data.programs;
        this.program_cfg = data.program_cfg;
        this.iot_list = data.iot_list;
        this.imt_list = data.imt_list;
        this.us_states = data.us_states;
        this.statuses = data.statuses;
        this.substatuses = data.substatuses;
        this.status_cfg = data.status_cfg;
        this.payment_systems = data.payment_systems;
        this.loaded = true;
        this.dmtModuleHeaderUpdateDate = data.dmt_module_properties.dmtModuleHeaderUpdateDate;
        this.generalDeterminationCutoverDate = data.dmt_module_properties.generalDeterminationCutoverDate;
        this.misc_codes = data.misc_codes;
    };
    /*
        updateIot() {
            if (!this.iot_list.calculated) {
                this.iot_list.iots = this.country_list.filter(this.getIOT);
                this.iot_list.calculated = true;
            }
        }
    */
    SettingsService.prototype.getIOT = function (iot) {
        if (iot.ic === 'IOT') {
            return iot;
        }
    };
    ;
    SettingsService.prototype.calcIot = function (short) {
        var foundIot = '';
        angular.forEach(this.country_list, function (ctry) {
            if (ctry.short === short) {
                foundIot = ctry.imt;
            }
        });
        return foundIot;
    };
    SettingsService.prototype.calcCountryObj = function (short) {
        var foundObj = { short: '' };
        angular.forEach(this.country_list, function (ctry) {
            if (ctry.short === short) {
                foundObj = ctry;
            }
        });
        return foundObj;
    };
    SettingsService.prototype.getShortName = function (country) {
        var foundShort;
        angular.forEach(this.country_list, function (ctry) {
            if (ctry.country === country) {
                foundShort = ctry.short;
            }
        });
        return foundShort;
    };
    /**
     * getCountryList - Pull list of country names only
     *
     * @return {type}  Array of country names
     */
    SettingsService.prototype.getCountryList = function () {
        var cty = [];
        if (Array.isArray(this.country_list)) {
            this.country_list.forEach(function (c) {
                if (c.ic.toLowerCase() === 'country') {
                    cty.push(c.country);
                }
            });
        }
        return cty;
    };
    SettingsService.prototype.updateProfile = function (data) {
        this.up = data;
    };
    SettingsService.$inject = ['socket', 'env'];
    return SettingsService;
}());
angular
    .module('application')
    .service('settings', SettingsService);

//# sourceMappingURL=settings.js.map
